import { createFileRoute } from '@tanstack/react-router';
import { PlaybookEditor } from '@/components/playbook';
import { SettingsSubPageHeader } from '@/components/settings';

export const Route = createFileRoute('/app/settings/playbook')({
  component: PlaybookPage,
});

export function PlaybookPage() {
  return (
    <div className="max-w-3xl p-6">
      <SettingsSubPageHeader
        title="Your playbook"
        description="Your advice for candidates, in your words. When a campaign names you its consultant, the assistant coaches that campaign from this playbook. One playbook covers every campaign you consult for."
      />
      <div className="mt-6">
        <PlaybookEditor />
      </div>
    </div>
  );
}
